export default "__VITE_ASSET__B5Ycd59C__"